import type { NavItem } from 'finara-components';

export const superAdminNavItems: NavItem[] = [
  { text: 'Dashboard General', url: '/dashboard' },
  {
    title: 'Clientes',
    links: [
      { text: 'Listado de Clientes', url: '/clientes' },
      { text: 'Usuarios sin Organización', url: '/clientes/sin-organizacion' },
      { text: 'Revisión Onboarding', url: '/clientes/onboarding-review' },
      { text: 'Revisión de Parámetros', url: '/clientes/parametros-revision' },
    ],
  },
  {
    title: 'Operaciones',
    links: [
      { text: 'Operaciones Generales', url: '/operaciones/generales' },
      { text: 'Adelantos de Nómina', url: '/operaciones/adelantos-de-nomina' },
    ],
  },
  {
    title: 'Reportes & Datos',
    links: [
      { text: 'Estados de Cuenta', url: '/reportes/estados-de-cuenta' },
      { text: 'Evaluación de Riesgos', url: '/reportes/evaluacion-de-riesgos' },
    ],
  },
  {
    text: 'Configuración & Seguridad',
    url: '/seguridad',
  },
];

export const adminNavItems: NavItem[] = [
  { text: 'Dashboard', url: '/dashboard', active: true },
  { text: 'Clientes', url: '/clientes' },
  { text: 'Operaciones', url: '/operaciones' },
  {
    title: 'Reportes',
    links: [{ text: 'Reportes Financieros', url: '/reportes/financieros' }],
  },
];

export const viewerNavItems: NavItem[] = [
  { text: 'Dashboard', url: '/dashboard', active: true },
  { text: 'Reportes', url: '/reportes' },
];
